import { render, staticRenderFns } from "./ProfileAsideComponent.vue?vue&type=template&id=26716695"
import script from "./ProfileAsideComponent.vue?vue&type=script&lang=js"
export * from "./ProfileAsideComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileAsideComponent.vue?vue&type=style&index=0&id=26716695&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26716695')) {
      api.createRecord('26716695', component.options)
    } else {
      api.reload('26716695', component.options)
    }
    module.hot.accept("./ProfileAsideComponent.vue?vue&type=template&id=26716695", function () {
      api.rerender('26716695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/ProfileAsideComponent.vue"
export default component.exports